module.exports = __webpack_public_path__ + "static/media/header-left-hexes.81a95bb2.svg";